import { HighlightedCode } from '@/components/code/HighlightedCode';
import { highlightSubscription } from '@/lib/subscriptionCode';
import type { TaskSubscription } from '@rock/types';
import { type FC, useMemo } from 'react';

/** A task type's cadence as read-only code, field for field as it is stored. */
export const SubscriptionCode: FC<{ subscription: TaskSubscription; block?: boolean }> = ({ subscription, block }) => {
    const stretches = useMemo(() => highlightSubscription(subscription, { multiline: block }), [subscription, block]);
    return <HighlightedCode stretches={stretches} block={block} />;
};
